<template>
  <div class="container mt-4" dir="rtl">
    
    <!-- زر الطباعة -->
<!-- حاوية مرنة (Flex Container) بتنسيق كارت -->
<div class="d-flex flex-column flex-md-row justify-content-between align-items-center mb-4 p-3 bg-white rounded shadow-sm border-end border-5 border-primary no-print gap-3">
  
  <!-- 1. العنوان والأيقونة -->
  <div class="d-flex align-items-center w-100 w-md-auto justify-content-center justify-content-md-start">
    
    <!-- مربع أيقونة جمالي -->
    <div class="icon-box bg-primary-subtle text-primary rounded-circle ms-3 d-flex align-items-center justify-content-center flex-shrink-0">
      <i class="fas fa-file-contract fs-5"></i>
    </div>
    
    <!-- النص -->
    <div>
      <h5 class="fw-bold text-dark m-0">تعليمات وتوجيهات المنظومة</h5>
      <small class="text-muted d-none d-sm-block">يرجى قراءة التعليمات بعناية قبل الطباعة</small>
    </div>
  </div>

  <!-- 2. زر الطباعة -->
  <button @click="printPage" class="btn btn-dark px-4 py-2 w-100 w-md-auto shadow-sm transition-btn">
    <i class="fas fa-print ms-2"></i> طباعة التعليمات
  </button>

</div>
    <!-- منطقة الورقة (الطباعة) -->
    <div class="paper-document p-3 p-md-5 mx-auto" id="printMe">
      
      <!-- 1. الترويسة -->
      <div class="header-section mb-3 border-bottom pb-3">
        <div class="row align-items-center gy-3 text-center">
          
          <!-- اليمين (في الموبايل يظهر الأول) -->
          <div class="col-12 col-md-4 text-md-start order-1">
            <h6 class="fw-bold mb-1">محافظة: شمال سيناء</h6>
            <h6 class="fw-bold mb-1">مديرية التربية والتعليم</h6>
            <h6 class="fw-bold mb-0">لجنة النظام والمراقبة</h6>
          </div>
          
          <!-- الوسط (العنوان) -->
          <div class="col-12 col-md-4 order-2">
            <h4 class="fw-bold text-decoration-underline mb-2 fs-5 fs-md-4">منظومة رصد الأنشطة</h4>
            <h6 class="fw-bold text-muted">تعليمات وضوابط العمل</h6>
          </div>

          <!-- اليسار -->
          <div class="col-12 col-md-4 text-md-end order-3">
            <h6 class="fw-bold mb-1">العام الدراسي: 2025 / 2026</h6>
            <h6 class="fw-bold mb-0">شئون الطلبة والامتحانات</h6>
          </div>
        </div>
      </div>

      <!-- ========================================== -->
      <!-- التنبيه الهام -->
      <!-- ========================================== -->
     <!-- إضافة mt-4 لعمل مسافة علوية للشارة العائمة -->
<div class="notice-box border border-danger border-2 rounded-3 position-relative mt-5 mb-4 text-center mx-auto" style="max-width: 800px;">
  
  <!-- الشارة العائمة (Badge) -->
  <span 
        class="position-absolute top-0 translate-middle badge rounded-pill bg-danger border border-2 border-white px-4 py-2 fs-6 shadow-sm text-nowrap"
        style="left: 50%;"
    >
       <i class="fas fa-bullhorn ms-2"></i> تنبيه هام وعاجل
    </span>

  <!-- محتوى التنبيه -->
  <div class="p-3 pt-5 p-md-4"> <!-- pt-5 هام جداً لإبعاد النص عن الشارة -->
      
      <h5 class="fw-bold text-dark mb-3">بشأن إتاحة البيانات وبدء العمل</h5>
      
      <p class="mb-4 text-dark fs-6 lh-lg px-2">
          تعمل إتاحة بيانات الطلاب فورياً وتلقائياً بمجرد اعتماد المدرسة 
          <span class="text-decoration-underline fw-bold text-danger">لكشوف (12 د) الإلكترونية</span> 
          على موقع الوزارة.
      </p>

      <!-- صندوق الموعد -->
      <div class="date-box bg-white border border-danger rounded-2 d-inline-block px-3 py-2 shadow-sm mw-100">
          <span class="fw-bold text-danger d-flex align-items-center justify-content-center flex-wrap gap-2">
              <i class="far fa-calendar-alt"></i>
              <span>أقصى موعد لبدء الرصد:</span>
              <span class="dir-ltr d-inline-block bg-danger text-white px-2 rounded">1 / 1 / 2026</span>
          </span>
      </div>

  </div>
</div>

      <!-- ========================================== -->
      <!-- الهدف من المنظومة -->
      <!-- ========================================== -->
      <div class="rationale-box border border-primary border-1 rounded p-3 mb-4 bg-light">
        <div class="d-flex align-items-center mb-2 flex-wrap">
            <i class="fas fa-lightbulb text-primary fa-lg ms-2"></i>
            <h5 class="fw-bold text-primary mb-0 text-decoration-underline lh-base">الهدف من تفعيل هذه المنظومة:</h5>
        </div>
        <p class="text-dark mb-2 text-justify small-text lh-lg">
            نظراً لتوجهات الوزارة نحو <strong>تفعيل ملف التقييم الشامل</strong> للطلاب، ولتخفيف العبء الناتج عن تضخم البيانات في امتحانات (نصف وآخر العام)، فقد تقرر الآتي:
        </p>
        <ul class="mb-0 small-text pe-3">
            <li class="mb-1">إسناد جزء كبير من الدرجة للمدرسة مباشرة باعتبارها <strong>شريكاً أساسياً</strong>.</li>
            <li class="mb-1">تحويل المدرسة إلى "وحدة رصد" مسؤولة عن التقييمات الشهرية.</li>
            <li>ضمان دقة البيانات من المنبع قبل وصولها للكنترول.</li>
        </ul>
      </div>

      <!-- 2. جسم التعليمات الفنية -->
      <div class="instructions-body">
        
        <!-- قسم: مراجعة البيانات -->
        <h6 class="section-header bg-secondary text-white p-2 ps-3 fw-bold mb-2 rounded-1 d-flex align-items-center">
            <i class="fas fa-list-check ms-2"></i> أولاً: مراجعة الفئات الخاصة
        </h6>
        <ul class="list-group list-group-flush mb-3 small-text pe-0">
          <li class="list-group-item py-2 px-0 d-flex">
            <i class="fas fa-check-square ms-2 text-success mt-1"></i>
            <span>مطابقة قوائم النظام مع قوائم <strong>(1) سري</strong> بالمدرسة.</span>
          </li>
          <li class="list-group-item py-2 px-0 d-flex">
            <i class="fas fa-exclamation-circle ms-2 text-danger mt-1"></i>
            <span><strong>طلاب الدمج:</strong> التأكد من قراراتهم ورصد (اجتياز/إعفاء).</span>
          </li>
          <li class="list-group-item py-2 px-0 d-flex">
            <i class="fas fa-home ms-2 text-dark mt-1"></i>
            <span><strong>طلاب المنازل:</strong> (معفى / منازل) إلا في حال حضور العملي.</span>
          </li>
        </ul>

        <!-- قسم: ضوابط الرصد -->
        <h6 class="section-header bg-secondary text-white p-2 ps-3 fw-bold mb-2 rounded-1 d-flex align-items-center">
            <i class="fas fa-laptop-code ms-2"></i> ثانياً: ضوابط الرصد الإلكتروني
        </h6>
        <ul class="list-group list-group-flush mb-3 small-text pe-2">
          <li class="list-group-item py-1 px-0">1. تحري الدقة في اختيار (اجتياز / لم يجتز / غائب).</li>
          <li class="list-group-item py-1 px-0">2. الطالب المنقطع يرصد <strong>(غائب)</strong> ولا يترك فارغاً.</li>
          <li class="list-group-item py-1 px-0">3. الالتزام بالحفظ المرحلي للبيانات.</li>
        </ul>

        <!-- قسم: الاعتماد -->
        <h6 class="section-header bg-secondary text-white p-2 ps-3 fw-bold mb-2 rounded-1 d-flex align-items-center">
            <i class="fas fa-stamp ms-2"></i> ثالثاً: الطباعة والاعتماد
        </h6>
        <div class="border p-2 rounded small-text bg-white">
          <strong>بعد الانتهاء:</strong> تتم طباعة الكشوف ورقياً، ومراجعتها، واعتمادها بختم المدرسة وتوقيع المدير، وتسليمها للجنة النظام والمراقبة.
        </div>

      </div>

      <!-- 3. الإقرار والتوقيع -->
      <div class="mt-4 pt-3 border-top">
        <div class="row text-center gy-4"> <!-- gy-4 مسافة رأسية في الموبايل -->
          <div class="col-6">
            <h6 class="fw-bold mb-4 small">مسئول المعلومات</h6>
            <p>...................</p>
          </div>
          <div class="col-6">
            <h6 class="fw-bold mb-4 small">مدير المدرسة</h6>
            <p>...................</p>
          </div>
        </div>
        
        <div class="text-center mt-3">
          <p class="small text-muted mb-1">ختم المدرسة</p>
          <div class="stamp-box border border-dashed d-inline-block bg-light" style="width: 80px; height: 80px; border-radius: 50%;"></div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "SchoolManagerInstructions",
  methods: {
    printPage() {
      window.print();
    }
  }
};
</script>

<style scoped>
/* تنسيق مربع الأيقونة */
.icon-box {
  width: 45px;
  height: 45px;
  background-color: #cfe2ff; /* لون أزرق فاتح جداً */
}

/* تنسيق الحدود الملونة (RTL) */
.border-end {
  border-left: none !important;
  border-right: 5px solid #0d6efd !important; /* الشريط الأزرق الجانبي */
}

/* تأثير تحويم الزر */
.transition-btn {
  transition: all 0.3s ease;
}
.transition-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.2);
}

/* تحسينات للموبايل */
@media (max-width: 768px) {
  h5 {
    font-size: 1.1rem;
  }
  .icon-box {
    width: 35px;
    height: 35px;
  }
  .icon-box i {
    font-size: 1rem !important;
  }
}
/* 1. التنسيقات الأساسية (للموبايل أولاً) */
.paper-document {
  background-color: white;
  border: 1px solid #ddd;
  /* العرض مرن افتراضياً للموبايل */
  width: 100%;
  min-height: auto;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 14px;
}

/* 2. تنسيقات الشاشات الكبيرة (Desktop) */
@media (min-width: 992px) {
  .paper-document {
    /* العرض الثابت A4 يظهر فقط على الشاشات الكبيرة */
    width: 210mm;
    min-height: 297mm;
  }
}

/* تنسيق النصوص */
.text-justify { text-align: justify; }
.small-text { font-size: 0.95rem; line-height: 1.6; }
.lh-base { line-height: 1.5; }

/* الصناديق الملونة */
.rationale-box { background-color: #f8f9fa; border-right: 4px solid #0d6efd !important; }
.notice-box { background-color: #fff5f5; }
.list-group-item { border: none; background: transparent; }

/* 3. تنسيقات الطباعة (Strict Layout) */
@media print {
  @page {
    size: A4;
    margin: 10mm;
  }
  
  body { background-color: white; }
  .no-print { display: none !important; }

  /* إعادة ضبط الحاوية لتملأ الورقة */
  .paper-document {
    width: 100% !important;
    max-width: 100% !important;
    border: none;
    padding: 0 !important;
    margin: 0 !important;
  }

  /* إجبار التخطيط على 3 أعمدة في الترويسة حتى لو الطباعة من موبايل */
  .col-md-4 {
    width: 33.3333% !important;
    float: right !important; /* لدعم RTL */
    flex: 0 0 33.3333% !important;
  }
  
  /* محاذاة النصوص في الطباعة */
  .text-md-start { text-align: right !important; }
  .text-md-end { text-align: left !important; }
  
  /* إظهار الألوان */
  * {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
  
  .fas { display: none; } /* إخفاء الأيقونات في الطباعة لجعلها أكثر رسمية */
  
  /* تحسينات الحدود */
  .notice-box { border: 2px solid red !important; }
  .rationale-box { border: 1px solid #0d6efd !important; background-color: #f0f0f0 !important; }
  .bg-secondary { background-color: #6c757d !important; color: white !important; }
}
</style>